import { z } from 'zod';

export const StaffConversationLastMessageSchema = z.object({
  kind: z.enum(['text', 'image', 'video', 'audio']),
  text: z.string().min(1).nullable(),
  sentAt: z.iso.datetime(),
  authorKind: z.enum(['consumer', 'staff']),
});
export type StaffConversationLastMessage = z.infer<typeof StaffConversationLastMessageSchema>;

export const StaffConversationListItemSchema = z.object({
  conversationId: z.uuid(),
  consumerId: z.uuid(),
  consumerDisplayName: z.string().min(1),
  updatedAt: z.iso.datetime(),
  lastMessage: StaffConversationLastMessageSchema.nullable(),
  /** Consumer messages after the staff read cursor. */
  unreadCount: z.number().int().nonnegative(),
});
export type StaffConversationListItem = z.infer<typeof StaffConversationListItemSchema>;

export const StaffConversationsResponseSchema = z.object({
  items: z.array(StaffConversationListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});
export type StaffConversationsResponse = z.infer<typeof StaffConversationsResponseSchema>;
